import {
  Code2,
  Users,
  Cloud,
  Workflow,
  Smartphone,
  ShieldCheck,
  BarChart3,
  GraduationCap,
  Lightbulb,
  type LucideIcon,
} from 'lucide-react'

export interface Capability {
  icon: LucideIcon
  title: string
  description: string
}

// Os 3 pilares oficiais da i3 (vide brandbook)
export const capabilities: Capability[] = [
  {
    icon: Lightbulb,
    title: 'Consultoria em TI',
    description:
      'Estratégia tecnológica de ponta a ponta. Avaliamos seu cenário, desenhamos a arquitetura ideal e te acompanhamos na execução — sem virar "departamento da consultoria".',
  },
  {
    icon: Code2,
    title: 'Engenharia de Software',
    description:
      'Times integrados que entregam software de qualidade. Backend (.NET, Node), frontend (React, Vite), mobile, infraestrutura, DevOps e SRE — squad as a service ou projeto fechado.',
  },
  {
    icon: GraduationCap,
    title: 'Treinamentos',
    description:
      'Programa ativo de capacitação. Abrimos espaço pra júniors, recém-formados e pessoas de baixa renda — formamos a próxima geração de devs com mentoria sênior e prática real.',
  },
]

export interface Service {
  icon: LucideIcon
  title: string
  description: string
}

export const services: Service[] = [
  {
    icon: Code2,
    title: 'Web Development',
    description: 'Aplicações web modernas com React + Vite + .NET. Performance, acessibilidade e SEO desde o dia zero.',
  },
  {
    icon: Smartphone,
    title: 'Mobile Apps',
    description: 'Apps nativos ou React Native com UX cuidada e integração total com seu backend.',
  },
  {
    icon: Users,
    title: 'Squad as a Service',
    description: 'Time integrado ao seu — PM, Dev, QA, DevOps. Colaboração de verdade, sem terceirização de problema.',
  },
  {
    icon: ShieldCheck,
    title: 'Cyber Security',
    description: 'Audits, hardening, secrets management e implementação de SAST/DAST no seu pipeline.',
  },
  {
    icon: BarChart3,
    title: 'Data Analytics',
    description: 'Pipelines de dados, dashboards executivos e cultura analytics com SQL, dbt e Metabase/Grafana.',
  },
  {
    icon: Cloud,
    title: 'DevOps & SRE',
    description: 'CI/CD, IaC, observabilidade end-to-end. Você dorme tranquilo, a gente cuida do incident response.',
  },
  {
    icon: Workflow,
    title: 'Arquitetura & Discovery',
    description: 'Sessions de discovery, RFC, ADR e desenho de arquitetura — Clean Architecture, DDD, microsserviços quando faz sentido.',
  },
  {
    icon: GraduationCap,
    title: 'Trilhas de Capacitação',
    description: 'Trilhas formativas em .NET, React e DevOps — pra empresas que querem formar time interno ou indivíduos buscando entrar na área.',
  },
]
